/*jshint esversion: 6 */
import $ from 'jquery';

function tick($images, currentImage, callback) {
  let imagesLength = $images.length;
  let $currentImage = $($images[currentImage]);
  let $nextImage;

  if (currentImage + 1 < imagesLength) {
    $nextImage = $($images[currentImage + 1]);
  } else {
    $nextImage = $($images[0]);
  }

  $currentImage.css({zIndex: 0});
  $nextImage.css({display: 'block', opacity: 0, zIndex: 1});

  $nextImage.animate({opacity: 1}, 1000, () => {
    $currentImage.hide();
    callback();
  });
}

function initAnimation($container) {
  const $images = $container.find('.intro__image');
  const imagesLength = $images.length;
  let currentImage = 0;

  let initTick = () => {
    //let timeout = Math.random() * 5000 + 1000;
    let timeout = 3000;

    setTimeout(() => {
      tick($images, currentImage, initTick);
    }, timeout);

    if (currentImage + 1 >= imagesLength) {
      currentImage = 0;
    } else {
      currentImage += 1;
    }
  };

  tick($images, currentImage, initTick);
}

function intro() {
  const $main = $('.intro');
  if ($main.length < 1) return;
  initAnimation($main);
}

export default intro;
